import {
  type EdgeRecord,
  type NodeRecord,
  getRecordEntries,
} from '@ipfabric/utils';
import type { NodesEdgesMap } from 'components/Graph/model/GraphData';
import { record } from 'fp-ts';

export function buildNodesEdgesMap(
  nodes: NodeRecord,
  edges: EdgeRecord,
): NodesEdgesMap {
  return extendNodesEdgesMap(nodes, edges, {});
}

export function extendNodesEdgesMap(
  nodes: NodeRecord,
  edges: EdgeRecord,
  addToMap: NodesEdgesMap,
): NodesEdgesMap {
  const map: NodesEdgesMap = record.keys(nodes).reduce((result, nodeId) => {
    result[nodeId] = new Set();
    return result;
  }, addToMap);
  for (const [edgeId, edgeData] of getRecordEntries(edges)) {
    map[edgeData.source]?.add(edgeId);
    map[edgeData.target]?.add(edgeId);
  }
  return map;
}
